
<template>
  <div>
    <v-form ref="form" lazy-validation :readonly="read_only || !editing_role_and_default_comissions" v-if="!loading">
      <div class="d-flex justify-center flex-column flex-wrap">
        <!-- Botões -->
        <div class="d-flex justify-space-around mb-3 flex-wrap" v-if="!read_only">
          <v-btn small class="white--text font-weight-bold" :disabled="edit.default_comission"
            color="primary" @click="edit.role = true"> <v-icon small left>mdi-pencil</v-icon> cargo</v-btn>

          <v-btn small class="white--text font-weight-bold" :disabled="edit.role" v-if="has_commission" color="primary"
            @click="edit.default_comission = true"> <v-icon small left>mdi-pencil</v-icon> comissao padrão</v-btn>
          
          <v-btn v-if="employee_has_roles" :disabled="edit.role || true"
          small class="white--text font-weight-bold"  color="primary"
          @click="edit.commission_products = true, edit.products_comission = true" > 
            <v-icon small left>mdi-pencil</v-icon> 
            comissao por produtos
          </v-btn>
        </div>
        <!-- Informações básicas -->
        <v-row>
          <v-col cols="12">
            <v-text-field :value="new_employee.roleTrans" label="Cargo atual" readonly disabled
            prepend-icon="mdi-badge-account" class="mx-1"></v-text-field>
          </v-col>
          <v-col cols="12" :md="has_and_can_edit_goals ? '6' : '12'">
            <v-text-field v-model="new_employee.salary"  v-money="money" label="Salário" :readonly="read_only || !editing_role_and_default_comissions"
            prepend-icon="mdi-currency-usd" class="mx-1"></v-text-field>
          </v-col>
          <v-col cols="12" :md="'6'">
            <v-text-field
              v-if="has_and_can_edit_goals" readonly="read_only"
              v-model="new_employee.goals_attributes.goal" :rules="[...required]" label="Meta (sacos vendidos)"
              prepend-icon="mdi-bullseye" class="mx-1">
            </v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <!-- Edição de Cargo  -->
      <div v-if="edit.role">
        <div class="d-flex mt-2">
          <h4 style="color: #607D8B">Novo cargo</h4>
          <v-spacer></v-spacer>
          <f-btn cancel small @click="edit.role = false">
          </f-btn>
        </div>
        <v-autocomplete v-model="new_employee.newRole" :items="allRoles_computed" label="Novo cargo"
          hide-no-data item-text="attributes.translated" item-value="attributes.name"
          item-disabled="attributes.off" @input="checkComissions(new_employee.newRole, 'save', null)"
          :rules="[...required]">
          <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
        </v-autocomplete>
        <v-divider></v-divider>
      </div>
      <!-- Visualização e edição do modelo de comissões -->
      <div v-if="edit.default_comission || has_commission ">
        <div class="d-flex align-center mt-2" v-if="!read_only && (edit.role || edit.default_comission)">
          <h4 style="color: #607D8B">Novo modelo de comissão</h4>
          <v-spacer></v-spacer>
          <div  v-if="!edit.role">
            <f-btn cancel @click="edit.default_comission = false"></f-btn>
          </div>
        </div>
        <v-autocomplete v-model="new_employee[comission_map['comission_type']]" :items="comissions"
          :readonly="!editing_role_and_default_comissions"
          label="Modelo de comissão" hide-no-data item-text="name" item-value="value" item-disabled="off"
          :rules="[...required]">
          <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
        </v-autocomplete>

        <template v-if="new_employee[comission_map['comission_type']] == 1 ">
          <v-text-field v-model="new_employee[comission_map['comission_floor']]"
            :readonly="!editing_role_and_default_comissions" 
            :rules="[...required]" v-money="money3" label="Informe o valor (R$)"></v-text-field>
        </template>
        
        <template v-if="new_employee[comission_map['comission_type']] == 2  ">
          <v-text-field v-model="new_employee[comission_map['comission_floor']]"
            :readonly="!editing_role_and_default_comissions"
            :rules="[...required]" v-money="money3" hint="% do lucro" prepend-icon="mdi-percent"
            label="Informe a porcentagem (%)"></v-text-field>
        </template>
        
        <template v-if="new_employee[comission_map['comission_type']] == 3  ">
          <v-text-field v-model="new_employee[comission_map['comission_floor']]"
            :readonly="!editing_role_and_default_comissions"
            :rules="[...notZero3]" v-money="money3" label="Comissão inicial (R$)"></v-text-field>
          <v-text-field v-model="new_employee[comission_map['profit_floor']]"
            :readonly="!editing_role_and_default_comissions"
            :rules="[...notZero3]" v-money="money3" label="Lucro inicial (R$)"></v-text-field>
          <v-text-field v-model="new_employee[comission_map['profit_step']]"
            :readonly="!editing_role_and_default_comissions"
            :rules="[...notZero3]" v-money="money3" label="Lucro incremental (R$)"></v-text-field>
          <v-text-field v-model="new_employee[comission_map['comission_step']]"
            :readonly="!editing_role_and_default_comissions"
            :rules="[...notZero3]" v-money="money3" label="Comissão incremental (R$)"></v-text-field>
        </template>
        <template v-if="new_employee[comission_map['comission_type']] == 4  ">
          <v-text-field v-model="new_employee[comission_map['comission_floor']]"
            :readonly="!editing_role_and_default_comissions"
            :rules="[...required]" v-money="money3" label="Informe o valor (R$)">
          </v-text-field>
        </template>
        <template v-if="new_employee[comission_map['comission_type']] == 5  ">
          <v-text-field v-model="new_employee[comission_map['comission_floor']]"
            :readonly="!editing_role_and_default_comissions"
            :rules="[...notZeroPercentage]" v-money="money3" hint="% do frete" prepend-icon="mdi-percent"
            label="Informe a porcentagem (%)">
          </v-text-field>
        </template>
        <v-divider></v-divider>
      </div>
    </v-form>
    <card-loading-transparent v-if="loading"></card-loading-transparent>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from "@/mixins/validations.js"
import { VMoney } from 'v-money'

export default {
  name: 'EmployeeFinancialForm',
  mixins: [ validations ],
  directives: { money: VMoney },
  props: {
    read_only:{
      type: Boolean,
      default: false,
    },
    employee:{
      type: Object,
      default: () => { return {} },
    },
  },
  data() {
    return {
      loading: true,
      new_employee: {
        id: null,
        salary: 0.0,
      },
      edit: {
        commission_products: false,
        products_comission: false,
        default_comission: false,
        role: false,
      },
      comissions: [
        { name: 'Modelo 1 - R$ por unidade', value: 1, off: false },
        { name: 'Modelo 2 - % do lucro', value: 2, off: false },
        { name: 'Modelo 3 - Faixas', value: 3, off: false },
        { name: 'Modelo 4 - Gerente', value: 4, off: false },
        { name: 'Modelo 5 - Motorista', value: 5, off: false }
      ],
      has_commission: false,
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false
      },
      money3: {
        decimal: '.',
        thousands: ',',
        precision: 3,
        masked: false
      },
      new_comission_map:{
      comission_type: 'newComissionType',
      comission_floor: 'new_comissionFloor',
      profit_floor: 'new_profitFloor',
      profit_step: 'new_profitStep',
      comission_step: 'new_comissionStep',
      },
      read_comission_map:{
        comission_type: 'comissionTypeTransValue',
        comission_floor: 'comissionFloor',
        profit_floor: 'profitFloor',
        profit_step: 'profitStep',
        comission_step: 'comissionStep',
      },
    }
  },
  methods: {
    validate(){
      return this.prepareFinancialEmployee()
    },
    prepareComission(ct) {
      if (ct == 1 || ct == 4) { //vR$ * qtd
        this.new_employee.comissionTypeEnum = 3
      } else if (ct == 2 || ct == 5) { //v% * qtd
        this.new_employee.comissionTypeEnum = 1

      } else if (ct == 3) { //scale
        this.new_employee.comissionTypeEnum = 2
      } else {
        this.new_employee.comissionTypeEnum = 0
      }
      this.new_employee.comissionFloor = this.new_employee.new_comissionFloor
      this.new_employee.profitFloor = this.new_employee.new_profitFloor
      this.new_employee.comissionStep = this.new_employee.new_comissionStep
      this.new_employee.profitStep = this.new_employee.new_profitStep
    },
    prepareFinancialEmployee(){
      let form_is_valid = this.$refs.form.validate()
      if (form_is_valid) {
        if (!this.edit.role) {
          this.new_employee.newRole = this.new_employee.role
        }
        if (this.edit.default_comission || this.edit.role) {
          this.prepareComission(this.new_employee.newComissionType)
        }
        this.new_employee.salary_to_update = parseFloat(this.new_employee.salary.replace(/,/g, ''))
      } else {
        return false
      }
      this.$emit('setEmployee', this.new_employee)
      return true
    },
    checkComissions(job, state, comType) {//job is role
      var has = false
      var nr = job
      if (!String(nr).includes('Dir') && !String(nr).includes('Fin') && !String(nr).includes('Log')) {
        has = true
      } else {
        has = false
      }
      this.has_commission = has
      this.new_employee.newComissionType = null

      if (state == 'save') {
        this.comissions.forEach(c => {
          c.off = false
        });
        if (job == 'Seller' || job == 'Representative' || job == 4) {//vendedor
          this.comissions[3].off = true
          this.comissions[4].off = true
        } else if (job == 'Financial' || job == 'Auxiliar' || job == 'Director' || job == 'Logistics' ||
          job == 1 || job == 2 || job == 80) {//financeiro 5 + aux 80 + exec 6 => true ALL
          this.comissions.forEach(c => {
            c.off = true
          });
        } else if (job == 'Manager' || job == 5) {//gerente, id2
          this.comissions.forEach(c => {
            c.off = true
          });
          this.comissions[3].off = false
          this.new_employee.newComissionType = this.comissions[3].value
        } else if (job == 'Driver' || job == 3) {//motorista
          this.comissions.forEach(c => {
            c.off = true
          });
          this.comissions[4].off = false
          this.new_employee.newComissionType = this.comissions[4].value
        }
      } else if (state == 'load') {
        if (!(job == 'Financial' || job == 'Auxiliar' || job == 'Director')) {
          if (job == 'Driver') {
            this.new_employee.comissionTypeTrans = 'Modelo 5 - Motorista'
            this.new_employee.comissionTypeTransValue = 5
          } else if (job == 'Manager') {
            this.new_employee.comissionTypeTrans = 'Modelo 4 - Gerente'
            this.new_employee.comissionTypeTransValue = 4
          } else if (job == 'Seller' || job == 'Representative') {
            if (comType == 'fixed') {
              this.new_employee.comissionTypeTrans = 'Modelo 1 - R$ por unidade'
              this.new_employee.comissionTypeTransValue = 1
            } else if (comType == 'profit_step') {
              this.new_employee.comissionTypeTrans = 'Modelo 3 - Faixas'
              this.new_employee.comissionTypeTransValue = 3
            } else if (comType == 'percentage') {
              this.new_employee.comissionTypeTrans = 'Modelo 2 - % do lucro'
              this.new_employee.comissionTypeTransValue = 2
            }
          }
        }
      }
    },
    setNewEmployee(){
      this.loading = true
      if(this.employee?.data?.attributes){
        var { commision, comissionType, comissionFloor, profitFloor, comissionStep, profitStep, salary, comission_ids } = this.employee?.data?.attributes
        this.new_employee = {
          id: this.employee.data.attributes?.id,
          
          salary_to_update: null,
          commision: commision,
          comissionType: comissionType,
          comissionTypeTrans: null,
          comissionFloor: comissionFloor,
          profitFloor: profitFloor,
          comissionStep: comissionStep,
          profitStep: profitStep,
          newComissionType: null,
          new_comissionFloor: null,
          new_profitFloor: null,
          new_comissionStep: null,
          new_profitStep: null,
          comission_ids,
          comissions_attributes: [],
          salary
        }
        if (this.oneRole.includes('Sel') && this.employee.data?.attributes?.my_set_goal != null || this.oneRole.includes('Man') && this.employee.data?.attributes?.my_set_goal != null) {
          var { id, goal } = this.employee.data?.attributes?.my_set_goal?.data?.attributes
          const today = new Date()
          this.new_employee.goals_attributes = {
            id: id,
            goal: goal,
            due_date: (new Date(today.getUTCFullYear(), today.getMonth() + 1, 0)).toISOString().substring(0, 10)
          }
        }
        if (this.employee.data.attributes.role != null && this.employee?.data?.attributes?.role?.data?.[0]?.attributes) {
          this.new_employee.role = this.employee?.data?.attributes?.role?.data?.[0]?.attributes?.name,
            this.new_employee.roleTrans = this.employee.data.attributes.role.data[0].attributes.translated,
            this.new_employee.newRole = null,
  
            this.new_employee.vrt_account_attributes = this.employee.data.attributes.vrt_account.data.attributes
        }
        this.checkComissions(this.new_employee.role, 'load', this.new_employee.comissionType)
        this.checkComissions(this.new_employee.role, 'save', null)
      }
      this.loading = false
    },
    ...mapActions({
      getRoles: 'EmployeeRole/index',
    }),
  },
  computed: {
    comission_map(){
      return this.read_only || (!this.edit.default_comission && !this.edit.role) ? this.read_comission_map : this.new_comission_map
    },
    editing_role_and_default_comissions(){
      return this.edit.role || this.edit.default_comission
    },
    employee_has_roles(){
      return ['Seller', 'Manager'].includes(this.employee.data.attributes.role.data[0].attributes.name)
    },
    allRoles_computed() {
      if (this.allRoles) {
        this.allRoles.forEach(rol => {
          if (this.isDirector()) {
            rol.attributes.off = false
          } else if (this.isFinancial()) {
            if (rol.attributes.name.includes('Dir') || rol.attributes.name.includes('Man')) {
              rol.attributes.off = true
            } else {
              rol.attributes.off = false
            }
          } else if (this.isManager()) {
            if (rol.attributes.name.includes('Dir')) {
              rol.attributes.off = true
            } else {
              rol.attributes.off = false
            }
          }
        });
      }
      return this.allRoles
    },
    has_and_can_edit_goals(){
      return this.employee?.goals_attributes && (this.oneRole.includes('Sel') || this.oneRole.includes('Man'))
    },
    oneRole() {
      return this.employee?.data?.attributes?.role?.data?.[0]?.attributes?.name || []
    },
    
    ...mapState({
      allRoles: state => state.EmployeeRole.allRoles,
    })
  },
  mounted(){
    this.getRoles();
    this.setNewEmployee()
  },
  watch:{
    employee(){
      this.setNewEmployee()
    }
  }
}
</script>